import React, { useState } from "react";
import "../styles/user_management_styles.css";
import Navbar from "./Navbar.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import useFetch from "./useFetch.js";
import $ from "jquery";
import swal from "sweetalert";
import axios from "axios";
import { useEffect } from "react";
import MultiSelect from "./MultiSelect";
import config from "../config.js";
import "../fSelect.js";
import Cookie from "universal-cookie";
import mixpanel from "mixpanel-browser";

/**
 * NOTE:
 * - Styling updated to MQTT glass theme with responsive breakpoints.
 * - Logic, selectors, IDs, axios calls, and MultiSelect usage remain unchanged.
 * - All original control IDs (#alarm, #source, #title, #value, #direction, #color) preserved.
 */

const Alarms_Edit = () => {
  const cookies = new Cookie();
  let actionInitiatingUser = -1;
  let userToken = "";
  try {
    actionInitiatingUser = parseInt(cookies.get("userID"));
    userToken = cookies.get("userToken");
  } catch (error) {}
  const headers = {
    Authorization: `Bearer ${userToken}`,
    "Content-Type": "application/json",
  };

  let selectedUserGroups = [];

  const {
    data: sources,
    isPending: isPendingSources,
    error: errorSources,
  } = useFetch({
    actionInitiatingUser: actionInitiatingUser.toString(),
    URL: config.BACKEND_URL + "/logger_sources/sources",
  });
  const {
    data: alarmSettings,
    isPending: isPendingAlarmSettings,
    error: errorAlarmSettings,
  } = useFetch({
    actionInitiatingUser: actionInitiatingUser.toString(),
    URL: config.BACKEND_URL + "/alarms",
  });
  const {
    data: userGroups,
    isPending: isPendingUserGroups,
    error: errorUserGroups,
  } = useFetch({
    actionInitiatingUser: actionInitiatingUser.toString(),
    URL: config.BACKEND_URL + "/usergroups",
  });

  const [selectedAlarmUserGroups, setSelectedAlarmUserGroups] = useState([]);
  const [selectedAlarm, setSelectedAlarm] = useState(undefined);

  useEffect(() => {
    if (userGroups && userGroups.data) {
      if (!selectedAlarm) {
        setSelectedAlarmUserGroups([]);
        return;
      }
      const filterGrps = userGroups.data.filter((group) =>
        selectedAlarm.userGroupIDs.includes(group.id)
      );
      const ugrps = filterGrps.map((group) => ({
        label: group.name,
        value: group.id,
      }));
      setSelectedAlarmUserGroups((prevState) => {
        if (prevState.length !== ugrps.length) {
          return ugrps;
        }
        for (let i = 0; i < ugrps.length; i++) {
          if (ugrps[i].value !== prevState[i].value) {
            return ugrps;
          }
        }
        return prevState;
      });
    }
  }, [selectedAlarm, userGroups]);

  const handleSelectedUserGroupIDs = (selected) => {
    selectedUserGroups = selected;
  };

  const handleEditForm = async (e) => {
    e.preventDefault();
    mixpanel.track("Create Alarm Edit Button Clicked", {
      userID: cookies.get("userID"),
    });
    if (alarmSettings.length === 0) {
      swal("Error.", "No alarms found!", "error").then(() => {
        setSelectedAlarm(undefined);
      });
      return;
    }
    if (!selectedAlarm) {
      swal(
        "Alarm not selected!",
        "Select an alarm before it can be edited.",
        "error"
      );
      return;
    }
    if (!selectedUserGroups || selectedUserGroups.length === 0) {
      swal(
        "No user groups selected!",
        "Select at least one user group before it can be edited.",
        "error"
      );
      return;
    }
    const title = $("#title")[0].value,
      value = $("#value")[0].value,
      direction = $("#direction")[0].value,
      color = $("#color")[0].value,
      sourceId = parseInt($("#source")[0].value),
      userGroupIDs = selectedUserGroups.map((group) => group.value);
    const editBody = {
      title,
      color,
      value,
      sourceId,
      direction,
      userGroupIDs,
      actionInitiatingUser,
    };
    try {
      swal({
        title: "Are you sure?",
        text: "Do you want to edit the alarm?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await axios.patch(
            config.BACKEND_URL + `/alarms/${selectedAlarm.id}`,
            editBody,
            { headers }
          );
          swal(
            "Alarm updated!",
            "Alarm has been updated successfully.",
            "success"
          ).then(() => {
            window.location.reload();
          });
        } else {
          swal("Alarm not updated!", "", "info");
        }
      });
    } catch (err) {
      swal("Error!", err.message, "error");
    }
  };

  const handleAlarmSelect = (e) => {
    e.persist();
    if (e.target.value === "selectAlarmText") {
      setSelectedAlarm(undefined);
      return;
    } else {
      setSelectedAlarm(
        alarmSettings.find((alarm) => alarm.id === parseInt(e.target.value))
      );
    }
  };

  /* Injected MQTT-like responsive styles (desktop: centered select + stacked responsive form) */
  const injectedStyles = `
  .mqtt-page { min-height: 100vh; background: linear-gradient(180deg,#071026 0%, #061021 50%, #020617 100%); color: #e6eef8; padding-bottom: 48px; -webkit-font-smoothing:antialiased; -moz-osx-font-smoothing:grayscale; }
  .mqtt-container { max-width: 1100px; margin: 0 auto; padding: 28px 16px; }
  .mqtt-header { text-align:center; font-size:28px; font-weight:700; margin-bottom:8px; color:#e6eef8; text-shadow:0 8px 30px rgba(8,10,30,0.6); }
  .mqtt-sub { text-align:center; font-size:18px; color: rgba(203,213,225,0.8); margin-bottom:18px; }

  .mqtt-card { background: linear-gradient(180deg, rgba(15,23,42,0.72), rgba(5,10,20,0.72)); border: 1px solid rgba(99,102,241,0.12); box-shadow: 0 6px 20px rgba(2,6,23,0.7); border-radius: 12px; padding: 18px; color: #e6eef8; }

  .mqtt-row { display:flex; gap:20px; align-items:flex-start; flex-wrap:wrap; justify-content:center; }
  .mqtt-col { flex: 1 1 680px; min-width:280px; }
  .mqtt-form { width: 100%; max-width: 720px; margin: 0 auto; }

  .mqtt-section-title { font-size:20px; font-weight:600; color:#c7d6ff; margin-bottom:6px; }
  .mqtt-note { color: rgba(203,213,225,0.75); font-size:13px; margin-bottom:12px; text-align:center; }

  .mqtt-label { display:block; font-size:13px; margin-bottom:6px; color: rgba(203,213,225,0.85); }
  .mqtt-input, .mqtt-select { width:100%; padding:10px 12px; border-radius:8px; background: rgba(255,255,255,0.02); border:1px solid rgba(100,116,139,0.18); color:#e6eef8; font-weight:600; outline:none; transition: box-shadow 160ms ease, transform 120ms ease; }
  .mqtt-input:focus, .mqtt-select:focus { box-shadow: 0 6px 20px rgba(59,130,246,0.12); border-color: rgba(59,130,246,0.5); }

  .mqtt-actions { display:flex; justify-content:center; gap:12px; margin-top:14px; flex-wrap:wrap; }
  .mqtt-btn-primary { background: linear-gradient(90deg,#2563eb,#7c3aed); border:none; color:#fff; padding:10px 20px; border-radius:999px; cursor:pointer; font-weight:700; box-shadow: 0 6px 20px rgba(59,130,246,0.18); transition: transform 140ms ease, box-shadow 140ms ease; }
  .mqtt-btn-primary:active { transform: translateY(-1px) scale(1.01); box-shadow: 0 10px 30px rgba(59,130,246,0.22); }
  .mqtt-btn-secondary { background: transparent; border:1px solid rgba(148,163,184,0.12); color:#e6eef8; padding:10px 20px; border-radius:999px; cursor:pointer; font-weight:700; }

  .mqtt-select-wrapper { display:flex; justify-content:center; margin-bottom:18px; }
  .mqtt-select-inline { width:auto; min-width:220px; padding:8px 12px; border-radius:8px; background: rgba(255,255,255,0.02); border:1px solid rgba(100,116,139,0.18); color:#e6eef8; }

  .mqtt-card-small { padding:14px; border-radius:10px; }

  @media (max-width: 900px) {
    .mqtt-col { flex: 1 1 100%; }
    .mqtt-select-inline { width:100%; max-width:420px; }
  }
  `;

  return (
    <div className="mqtt-page Alarms_Edit" style={{ paddingTop: "38px" }}>
      <style dangerouslySetInnerHTML={{ __html: injectedStyles }} />
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
      />
      <Navbar />
      <main className="mqtt-container  ">
        <section className="mqtt-card mqtt-card-small">
          <header className="mqtt-header">Edit Alarm</header>
          <p className="mqtt-sub">Select the alarm you wish to edit.</p>

          <div className="mqtt-select-wrapper">
            {isPendingAlarmSettings && (
              <div style={{ fontSize: 18, color: "rgba(203,213,225,0.8)" }}>
                Loading...
              </div>
            )}

            {errorAlarmSettings && (
              <div style={{ fontSize: 18, color: "rgba(203,213,225,0.8)" }}>
                Could not fetch the alarms!
              </div>
            )}

            {alarmSettings &&
              (alarmSettings.length === 0 ? (
                <div style={{ fontSize: 18, color: "rgba(203,213,225,0.8)" }}>
                  Currently, there are no alarms!
                </div>
              ) : (
                <select
                  name="alarm"
                  id="alarm"
                  className="mqtt-select-inline"
                  onChange={handleAlarmSelect}
                  defaultValue="selectAlarmText"
                  aria-label="Choose alarm"
                >
                  <option value="selectAlarmText">Choose alarm</option>
                  {alarmSettings.map((alarm) => (
                    <option
                      key={alarm.id}
                      value={alarm.id}
                      style={{ color: "black" }}
                    >
                      {alarm.title}
                    </option>
                  ))}
                </select>
              ))}
          </div>

          <div className="mqtt-row">
            <div className="mqtt-col">
              {selectedAlarm && (
                <form
                  onSubmit={handleEditForm}
                  className="mqtt-form"
                  autoComplete="off"
                >
                  <div className="mqtt-card mqtt-card-small">
                    <div>
                      <div className="mqtt-section-title">
                        Edit Selected Alarm
                      </div>
                      <div className="mqtt-note">
                        Make changes and submit to update the alarm.
                      </div>
                    </div>

                    {/* Source selector (keeps original logic and selection behavior) */}
                    <div style={{ marginTop: 12 }}>
                      <label className="mqtt-label" htmlFor="source">
                        Data Source
                      </label>
                      {isPendingSources && (
                        <div
                          style={{
                            fontSize: 15,
                            color: "rgba(203,213,225,0.85)",
                          }}
                        >
                          Loading...
                        </div>
                      )}
                      {errorSources && (
                        <div
                          style={{
                            fontSize: 15,
                            color: "rgba(203,213,225,0.85)",
                          }}
                        >
                          Cannot fetch the sources right now!
                        </div>
                      )}
                      {sources && sources.data && sources.data.length === 0 && (
                        <div
                          style={{
                            fontSize: 15,
                            color: "rgba(203,213,225,0.85)",
                          }}
                        >
                          Currently, there are no data sources!
                        </div>
                      )}
                      {sources && sources.data && sources.data.length > 0 && (
                        <select
                          id="source"
                          className="mqtt-select"
                          name="source"
                          defaultValue={String(selectedAlarm.sourceId)}
                        >
                          <option value="selectSourceText">
                            Choose a source
                          </option>
                          {sources.data.map((source, index) => {
                            // NOTE: keep the rendering logic intact (no change to selected semantics)
                            return (
                              <option key={index} value={source.id}>
                                {source.name}
                              </option>
                            );
                          })}
                        </select>
                      )}
                    </div>

                    {/* User groups */}
                    <div style={{ marginTop: 14 }}>
                      {isPendingUserGroups && (
                        <div
                          style={{
                            fontSize: 15,
                            color: "rgba(203,213,225,0.85)",
                          }}
                        >
                          Loading...
                        </div>
                      )}
                      {errorUserGroups && (
                        <div
                          style={{
                            fontSize: 15,
                            color: "rgba(203,213,225,0.85)",
                          }}
                        >
                          Cannot fetch the user groups right now!
                        </div>
                      )}
                      {userGroups &&
                        (userGroups.length === 0 ? (
                          <div
                            style={{
                              fontSize: 15,
                              color: "rgba(203,213,225,0.85)",
                            }}
                          >
                            Currently, there are no user groups!
                          </div>
                        ) : (
                          <>
                            <label className="mqtt-label" htmlFor="userGroups">
                              User groups associated with this alarm
                            </label>
                            <div style={{ marginBottom: 6 }}>
                              <MultiSelect
                                id="userGroups"
                                data={userGroups.data.map((group) => ({
                                  label: group.name,
                                  value: group.id,
                                }))}
                                handleChange={handleSelectedUserGroupIDs}
                                placeholder="Search for, or select user group names..."
                                defaultSelected={selectedAlarmUserGroups}
                              />
                            </div>
                          </>
                        ))}
                    </div>

                    {/* Title */}
                    <div style={{ marginTop: 12 }}>
                      <label className="mqtt-label" htmlFor="title">
                        Title
                      </label>
                      <input
                        id="title"
                        type="text"
                        className="mqtt-input"
                        required
                        name="username"
                        value={selectedAlarm.title}
                        onChange={(e) =>
                          setSelectedAlarm({
                            ...selectedAlarm,
                            title: e.target.value,
                          })
                        }
                      />
                    </div>

                    {/* Value */}
                    <div style={{ marginTop: 12 }}>
                      <label className="mqtt-label" htmlFor="value">
                        Value
                      </label>
                      <input
                        id="value"
                        type="number"
                        className="mqtt-input"
                        required
                        name="value"
                        value={selectedAlarm.value}
                        onChange={(e) =>
                          setSelectedAlarm({
                            ...selectedAlarm,
                            value: e.target.value,
                          })
                        }
                      />
                    </div>

                    {/* Direction */}
                    <div style={{ marginTop: 12 }}>
                      <label className="mqtt-label" htmlFor="direction">
                        Direction
                      </label>
                      <select
                        id="direction"
                        className="mqtt-select"
                        value={selectedAlarm.direction}
                        onChange={(e) =>
                          setSelectedAlarm({
                            ...selectedAlarm,
                            direction: e.target.value,
                          })
                        }
                      >
                        <option value=">">Upper Limit</option>
                        <option value="<">Lower Limit</option>
                      </select>
                    </div>

                    {/* Color */}
                    <div
                      style={{
                        marginTop: 12,
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <label className="mqtt-label" htmlFor="color">
                          Color
                        </label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 12,
                          }}
                        >
                          <input
                            id="color"
                            type="color"
                            className="mqtt-input"
                            style={{ width: 72, padding: 6 }}
                            value={selectedAlarm.color}
                            onChange={(e) =>
                              setSelectedAlarm({
                                ...selectedAlarm,
                                color: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="mqtt-actions">
                      <button type="reset" className="mqtt-btn-secondary">
                        Reset
                      </button>
                      <button type="submit" className="mqtt-btn-primary">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Alarms_Edit;
